import { render, staticRenderFns } from "./UpgradePlanCard.vue?vue&type=template&id=7974d30c&scoped=true"
import script from "./UpgradePlanCard.vue?vue&type=script&lang=js"
export * from "./UpgradePlanCard.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlanCard.vue?vue&type=style&index=0&id=7974d30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7974d30c",
  null
  
)

export default component.exports